import Vue from 'vue';
import ImageFile from './ImageFile';
import MyEditor from './myEditor.vue';
import selectPBBrand from './selectPBBrand.vue'
import selectPBBrandClear from './selectPBBrandClear.vue'

const MyComponents = {
    install: function () {
        Vue.component('ImageFile',ImageFile)
        Vue.component('MyEditor',MyEditor)
        Vue.component('selectPBBrand',selectPBBrand)
         Vue.component('selectPBBrandClear',selectPBBrandClear)
    }
};

export default MyComponents;
